module.exports = __webpack_public_path__ + "static/media/user.f6489f64.svg";